"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerClient = void 0;
var client_1 = require("./client");
Object.defineProperty(exports, "CustomerClient", { enumerable: true, get: function () { return client_1.CustomerClient; } });
//# sourceMappingURL=index.js.map